var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstallments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 0.666672H1.99967C1.08301 0.666672 0.333008 1.41667 0.333008 2.33334V15.6667C0.333008 16.5833 1.08301 17.3333 1.99967 17.3333H11.9997C12.9163 17.3333 13.6663 16.5833 13.6663 15.6667V5.66667L8.66634 0.666672ZM1.99967 15.6667V2.33334H7.83301V5.66667H11.9997V15.6667H1.99967ZM6.16634 14.8333H7.83301V14H8.66634C9.12467 14 9.49967 13.625 9.49967 13.1667V10.6667C9.49967 10.2083 9.12467 9.83334 8.66634 9.83334H6.16634V9.00001H9.49967V7.33334H7.83301V6.50001H6.16634V7.33334H5.33301C4.87467 7.33334 4.49967 7.70834 4.49967 8.16667V10.6667C4.49967 11.125 4.87467 11.5 5.33301 11.5H7.83301V12.3333H4.49967V14H6.16634V14.8333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallments);
export default __webpack_public_path__ + "static/media/installments.6f3790a3.svg";
export { ForwardRef as ReactComponent };